import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/exchangeRates', request)
}

export {get}
